import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'timeCommitment'

const OPTIONS = [
  {
    value: 'A few minutes a day',
    translationKey: 'pages.onboarding.v1.timeCommitment.options.fewMinutes',
    emoji: '⚡',
  },
  {
    value: 'Weekend projects',
    translationKey: 'pages.onboarding.v1.timeCommitment.options.weekend',
    emoji: '📅',
  },
  {
    value: 'Full renovation mode',
    translationKey: 'pages.onboarding.v1.timeCommitment.options.fullRenovation',
    emoji: '🔨',
  },
  {
    value: 'Just browsing ideas',
    translationKey: 'pages.onboarding.v1.timeCommitment.options.browsing',
    emoji: '👀',
  },
]

export default function TimeCommitmentPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How much time can you dedicate to redesigning?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.timeCommitment.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
